import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { CameraSliceTypes, createCameraSlice } from './createCameraSlice';
import createSelectors from './createSelectors';
import { createSessionSlice, SessionSliceTypes } from './createSessionSlice';
import { createUserSlice, UserSliceTypes } from './createUserSlice';

export type RemoteBoundStoreState = UserSliceTypes &
  CameraSliceTypes &
  SessionSliceTypes;

const useRemoteBoundStoreBase = create<RemoteBoundStoreState>()(
  immer(
    devtools((...a) => ({
      ...createUserSlice(...a),
      ...createCameraSlice(...a),
      ...createSessionSlice(...a),
    })),
  ),
);

const useRemoteBoundStore = createSelectors(useRemoteBoundStoreBase);

export default useRemoteBoundStore;
